/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';

class DetailedTitledPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="page-title">
          <h3>{this.props.title}</h3>
        </div>
        <div className="page-details">{this.props.details}</div>
        <div className="page-content">{this.props.content}</div>
      </div>
    );
  }
}

export default DetailedTitledPage;
